import { Box, Paper, Typography, TextField, InputAdornment, IconButton, OutlinedInput } from "@mui/material";
import React, { useState, useEffect } from "react";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";

function ApiForm({ apiSetting, updateApiSetting }) {
  const [dataList, setDataList] = useState({});
  const [showPassword, setShowPassword] = useState(false);

  useEffect(() => {
    setDataList(apiSetting);
  }, [apiSetting]);

  const labelWidth = 130;

  const handleCreate = (property, event) => {
    const inputFormCopy = { ...dataList };
    inputFormCopy[property] = event.target.value;

    setDataList(inputFormCopy);
    updateApiSetting(inputFormCopy);
  };

  const handleClickShowPassword = () => setShowPassword((show) => !show);
  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  return (
    <Paper>
      <Box p={3}>
        <Typography variant="h5" mb={3} fontWeight="fontWeightMedium">
          API Settings
        </Typography>
        <Box display="flex" mb={2}>
          <Typography
            display="flex"
            alignItems="center"
            pr={4}
            sx={{ minWidth: labelWidth }}
          >
            Base URL
          </Typography>
          <TextField
            onChange={(event) => handleCreate("epicor_RestUrl", event)}
            value={dataList?.epicor_RestUrl}
            size="small"
            id="baseurl"
            variant="outlined"
            fullWidth
          />
        </Box>
        <Box display="flex" mb={2}>
          <Typography
            display="flex"
            alignItems="center"
            justifyContent="start"
            pr={4}
            sx={{ minWidth: labelWidth }}
          >
            API Key
          </Typography>
          <TextField
            size="small"
            id="apikey"
            value={dataList?.epicor_ApiKey}
            onChange={(event) => handleCreate("epicor_ApiKey", event)}
            variant="outlined"
            fullWidth
          />
        </Box>

        <Box display="flex" mb={2}>
          <Typography
            display="flex"
            alignItems="center"
            justifyContent="start"
            pr={4}
            sx={{ minWidth: labelWidth }}
          >
            Username
          </Typography>
          <TextField
            size="small"
            value={dataList?.epicor_UserName}
            onChange={(event) => handleCreate("epicor_UserName", event)}
            id="username"
            variant="outlined"
            fullWidth
          />
        </Box>

        <Box display="flex" mb={2}>
          <Typography
            display="flex"
            alignItems="center"
            justifyContent="start"
            pr={4}
            sx={{ minWidth: labelWidth }}
          >
            Password
          </Typography>
          <OutlinedInput
            size="small"
            id="password"
            type={showPassword ? "text" : "password"}
            value={dataList?.epicor_Password}
            onChange={(event) => handleCreate("epicor_Password", event)}
            variant="outlined"
            fullWidth
            endAdornment={
              <InputAdornment position="end">
                <IconButton
                  onClick={handleClickShowPassword}
                  onMouseDown={handleMouseDownPassword}
                  edge="end"
                >
                  {!showPassword ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              </InputAdornment>
            }
          />
        </Box>
      </Box>
    </Paper>
  );
}

export default ApiForm;
